import { events } from '../names';
import { useSendEvent } from '../useSendEvent';

type Params = {
	mediaId?: string;
	botClientId: number | string;
};

export const usePhotoClicked = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.sextingPack.photoClicked, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useViewAllClicked = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.sextingPack.viewAllClicked, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useNavigationClicked = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.sextingPack.navigationClicked, {
		mediaId,
		bot_UserId: botClientId,
	});

export const useUnlockAllClicked = ({ mediaId, botClientId }: Params) =>
	useSendEvent(events.sextingPack.unlockAllClicked, {
		mediaId,
		bot_UserId: botClientId,
	});
